/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc5Inputs */

const en_fc_tut_sc5 = /** @type {(inputs: Fc_Tut_Sc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripple-trim start / end to playhead`)
};

/**
* | output |
* | --- |
* | "Ripple-trim start / end to playhead" |
*
* @param {Fc_Tut_Sc5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc5 = /** @type {((inputs?: Fc_Tut_Sc5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc5(inputs)
});
export { fc_tut_sc5 as "fc.tut.sc5" }